import { render, staticRenderFns } from "./EnquiryFollowUps.vue?vue&type=template&id=7a4986ae&scoped=true&"
import script from "./EnquiryFollowUps.vue?vue&type=script&lang=js&"
export * from "./EnquiryFollowUps.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryFollowUps.vue?vue&type=style&index=0&id=7a4986ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4986ae",
  null
  
)

export default component.exports